import React from 'react'

function VMSettings() {
  return (
    <div>VMSettings</div>
  )
}

export default VMSettings